import React from "react";

const APP_STORE_URL = "https://apps.apple.com/app/google-authenticator/id388497605";
const PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2";

export function MfaStoreBadges() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-3">
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block"
      >
        <img
          src="/app_store.png"
          alt="Download on the App Store"
          className="h-[48px] w-auto"
        />
      </a>
      <a
        href={PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block"
      >
        <img
          src="/google_play.png"
          alt="Get it on Google Play"
          className="h-10 w-auto"
        />
      </a>
    </div>
  );
}
